import { render, staticRenderFns } from "./vipinfos.vue?vue&type=template&id=19d6f5b4&scoped=true"
import script from "./vipinfos.vue?vue&type=script&lang=js"
export * from "./vipinfos.vue?vue&type=script&lang=js"
import style0 from "./vipinfos.vue?vue&type=style&index=0&id=19d6f5b4&prod&lang=less&scoped=true"
import style1 from "./vipinfos.vue?vue&type=style&index=1&id=19d6f5b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d6f5b4",
  null
  
)

export default component.exports